module.exports = __webpack_public_path__ + "img/36802-017.2f5a0ebb.jpg";